export enum ClientType {
    SINGLE_FAMILY = 'SINGLE_FAMILY',
    MULTI_FAMILY = 'MULTI_FAMILY',
    COMMERCIAL = 'COMMERCIAL'
}



// WEBPACK FOOTER //
// ./src/types/enums/ClientType.ts